var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col mx-auto w-1/4 max-lg:w-full lg:mt-12 items-center justify-center"},[_c('img',{staticClass:"h-[8em]",attrs:{"src":require("../assets/svg.svg"),"alt":""}}),_c('p',{staticClass:"text-center text-xl font-medium mt-4"},[_vm._v("Nenhum resultado encontrado")])])
}]

export { render, staticRenderFns }